import { Component, h, createRef } from 'preact';
import { InquiryStageCounts } from 'types/inquiries';
import { InquiryPageHeader } from './inquiry-page-header.component';

interface InquiryGridSlideProps {
  stageName: string;
  stageCount: number;
  stageActive: boolean;
  cardCounts: InquiryStageCounts;

  searchInput?: string;
  searchCount?: number;

  onLeftStageClick?: (event: Event) => void;
  onRightStageClick?: (event: Event) => void;
  onSearch?: (search?: string) => void;
  onFilterButtonClick?: () => void;
}

interface InquiryGridSlideState {
  headerSticky?: boolean;
  scrolled?: boolean;
}

export class InquiryGridSlide extends Component<InquiryGridSlideProps, InquiryGridSlideState> {
  slideRef = createRef<HTMLDivElement>();
  lastScrollY: number = 0;

  onScroll(event: UIEvent) {
    const slide = this.slideRef.current;
    const scrolled = slide.scrollTop > 100;
    const headerSticky = this.lastScrollY > slide.scrollTop && slide.scrollTop > 100;

    this.setState({ scrolled, headerSticky });
    this.lastScrollY = slide.scrollTop;
  }

  render(props: InquiryGridSlideProps, state: InquiryGridSlideState) {
    return (
      <div 
        className="hi-inqpage__slide"
        onScroll={ event => this.onScroll(event) }
        ref={ this.slideRef }
      >
        <InquiryPageHeader
          stageName={ props.stageName }
          stageCount={ props.stageCount }
          stageActive={ props.stageActive }
          cardCounts={ props.cardCounts }
          sticky={ state.headerSticky }
          scrolled={ state.scrolled }

          searchInput={ props.searchInput }
          searchCount={ props.searchCount }
          
          onLeftStageClick={ props.onLeftStageClick }
          onRightStageClick={ props.onRightStageClick }
          onSearch={ props.onSearch }
          onFilterButtonClick={ props.onFilterButtonClick } />
        { this.props.children }
      </div>
    );
  }
}